module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_3-a30c0ee5c95303e380d0348043c947fb.png";